<app-wrapper>

  <div class="mb-9">
    <div class="mb-4">
      <div class="row g-3">
        <div class="col-auto">
          <h2>
            <div class="d-inline pe-2 cursor-pointer" (click)="back()" title="Назад">
              <i class="fa-solid fa-arrow-left"></i>
            </div>
            Категория
          </h2>
        </div>
        <div class="col-auto flex-grow-1">
        </div>
        <div class="col-auto">
          <button (click)="save()" [disabled]="form.invalid" class="btn btn-primary">
            <i class="fa-solid fa-save"></i>&nbsp;Сохранить
          </button>
        </div>
      </div>
    </div>

    <div class="row g-5">
      <div class="col-12">
        <form #form="ngForm" class="card p-4">
          <div class="row">
            <div class="col-md-4 col-lg-2">
              <div class="form-group">
                <div class="form-floating mb-3">
                  <input type="text" name="name" [(ngModel)]="model.name" class="form-control"
                    required placeholder="Название категории">
                    <label>Название категории</label>
                  </div>
                </div>
              </div>
              <div class="col-md-4 col-lg-2">
                <div class="form-group">
                  <div class="form-floating mb-3">
                    <select name="parentId" [(ngModel)]="model.parentId" class="form-select" placeholder="Выберите категорию">
                      <option [ngValue]="undefined">Основная</option>
                      @for (current of categories; track current) {
                        <ng-container
                          [ngTemplateOutlet]="itemTemplateRef"
                          [ngTemplateOutletContext]="{item: current, level: 0, selectId: model.parentId}">
                        </ng-container>
                      }
                    </select>
                    <label>Родительская категория</label>
                  </div>
                </div>
              </div>
              <div class="col-md-3 col-lg-2">
                <div class="form-group">
                  <div class="form-check form-switch mb-3">
                    <input class="form-check-input" type="checkbox" name="isPublished"
                      [(ngModel)]="model.isPublished">
                      <label class="form-check-label" for="flexSwitchCheckDefault">Опубликованна</label>
                    </div>
                  </div>
                </div>
                <div class="col-md-4 col-lg-2">
                  <div class="form-group">
                    <div class="form-floating mb-3">
                      <input type="number" name="order" [(ngModel)]="model.order" class="form-control"
                        placeholder="Сортировка">
                        <label>Сортировка</label>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    @if (model.image) {
                      <div class="image mb-2">
                        <img [src]="model.image.path" [title]="model.image.originalName" />
                        <div class="overflow">
                          <div class="remove" (click)="removeImage()">
                            <i class="fa-solid fa-times"></i>
                          </div>
                        </div>
                      </div>
                    }
                    <label class="w-100">
                      Новое изображение
                      <input type="file" (change)="selectFile($event)" class="form-control"
                        accept="image/*" />
                      </label>
                    </div>
                  </div>
                </form>
              </div>
            </div>
            @if (isBusy) {
              <div class="overlay">
                <i class="fa-solid fa-spinner fa-spin"></i>
              </div>
            }
          </div>
        </app-wrapper>

        <ng-template #itemTemplateRef let-item="item" let-level="level" let-selectId="selectId">
          <option [selected]="item.id == selectId" [value]="item.id">{{ getSelectPrefix(level) }}{{ item.name }}</option>
          @for (current of item.categories; track current) {
            <ng-container [ngTemplateOutlet]="itemTemplateRef"
            [ngTemplateOutletContext]="{item: current, level: level + 1, selectId: selectId}"></ng-container>
          }
        </ng-template>